export class FormaDosaggioCriteria {
  soggettoAPrescrizione;
  dopante;
  inCommercio;
  sospeso;
  innovativo;
  orfano;
  pianoTerapeutico;
  carenza;


  constructor(filterData: any) {
    this.soggettoAPrescrizione = this._xor(filterData['soggettoAPrescrizione']);
    this.dopante = this._xor(filterData['dopante']);
    this.inCommercio = this._xor(filterData['inCommercio']);
    this.sospeso = this._xor(filterData['sospeso']);
    this.innovativo = this._xor(filterData['innovativo']);
    this.orfano = this._xor(filterData['orfano']);
    this.pianoTerapeutico = this._xor(filterData['pianoTerapeutico']);
    this.carenza = this._xor(filterData['carenza']);
  }

  _xor(data:any){
    let res
    //Verifico se sono valorizzati o solo il si o solo il no
    if ((data.si && !data.no) || (!data.si && data.no)) {
      //Se OK setto true se SI true altrimenti setto false se NO è true
      res = data.si && !data.no
    }
    //Negli altri casi torno undefined così non setto il filtro
    return res
  }
  getQueryString(): string{
    let qp = ''
    for (const [key, value] of Object.entries(this)) {
      if (value !== undefined)
        qp = qp + `${qp !== '' ? '&':''}${key}=${value}`
    }
    return qp;
  }
}
